export const calculatePercentage = (part: number, total: number) => {
  return total === 0 ? 0 : ((part || 0) / total) * 100;
};
